module.exports = __webpack_public_path__ + "static/media/calendar.5e11a49c.svg";